import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import { Book_Pooja } from '../../../../api/pooja/Pooja'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { toast } from "react-toastify";
import { IMG_BASE_URL } from '../../../../config/Config'
import Razor_Pay from '../../../../razor_pay/Razor_Pay'

const Book_Pooja_Payment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [package_popup, setPackageDetail] = useState(null)
    const [isBooking, setIsBooking] = useState(false);

    const { title, image, astro_name, price, id, description, short_description, pooja_id, poojalocation, full_address, package_detail, package_name, language, astro_user_id, pooja_date, from_time, muhurat_info } = location.state || {};

    const storedLocation = JSON.parse(localStorage.getItem("poojaLocation") || "{}");
    const finalFullAddress = full_address || storedLocation?.full_address || storedLocation?.zipcode || poojalocation || "";

    useEffect(() => {
        if (!location.state) {
            navigate("/pooja");
        }

    }, [location.state]);

    // Function to handle booking after payment success
    const Handle_Book_pooja = async (transaction_id) => {
        setIsBooking(true);
        const data = {
            id: id,
            title, image, astro_name, price: price, short_description, description, pooja_id, package_name: package_name, language: language, astro_user_id: astro_user_id, pooja_date, from_time, custom_detail: muhurat_info,
            location: poojalocation,
            full_address: finalFullAddress,
            paymentmethod: "Online",
            payment_status: "Success",
            transaction_id: transaction_id,
        };

        try {
            const token = User_Authentication();
            if (!token) {
                throw new Error("User token not found");
            }

            const response = await Book_Pooja(data, { Authorization: `Bearer ${token}` });
            if (response?.data?.status == "200") {
                toast("Pooja booked successfully");
                navigate("/user-my-pooja-list");
            } else {
                setIsBooking(false);
            }
        } catch (error) {
            toast("Failed to book pooja. Please try again.");
            setIsBooking(false);
        }
    };

    // Callback when Razorpay payment is successful
    const handlePaymentSuccess = ({ transaction_id, payment_status }) => {
        if (payment_status == "Success") {
            Handle_Book_pooja(transaction_id);
        }
    };

    const formatTimeTo12Hour = (time) => {
        const [hours, minutes] = time.split(":");
        const intHours = parseInt(hours, 10);
        const ampm = intHours >= 12 ? "pm" : "am";
        const formattedHours = intHours % 12 || 12;
        return `${formattedHours}:${minutes} ${ampm}`;
    };
    const handle_Package_Popup = (package_detail) => {
        setPackageDetail(package_detail)
    }

    const close_Package_Popup = () => {
        setPackageDetail(null);
    };

    return (
        <div>
            {/*  */}
            <Header />
            <section className="gi-checkout-section py-[40px] text-[12px] max-[767px]:py-[30px]">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 relative">
                    <div className="flex flex-wrap w-full">
                        {/* <!-- Sidebar Area Start --> */}
                        <div className="gi-checkout-leftside px-[12px] min-[992px]:w-[66.66%] w-full max-[991px]:mt-[30px]">
                            {/* <!-- checkout content Start --> */}
                            <div className="gi-checkout-content">
                                <div className="gi-checkout-inner">
                                    <div className="gi-checkout-wrap bg-[#fff] mb-[30px]">
                                        <div className="gi-checkout-block gi-check-login">
                                            <h3 className="text-gray-900 font-semibold text-lg">
                                                Pooja Info</h3>
                                            <div className="gi-product-content mt-3 shadow-xl p-5">
                                                <div className="flex gap-6">
                                                    <div className="text-center">
                                                        <img width={130} height={130}
                                                            src={`${IMG_BASE_URL}${image}`}
                                                            className="m-auto rounded max-w-full z-[1]"
                                                            alt="Pooja Image"
                                                        />
                                                    </div>
                                                    <div className="grid grid-cols-3 gap-3 flex-1">
                                                        {title && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{title}</span>
                                                            </div>
                                                        )}

                                                        {astro_name && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pandit</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{astro_name}</span>
                                                            </div>
                                                        )}

                                                        {price && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Amount</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">Rs. {price}/-</span>
                                                            </div>
                                                        )}

                                                        {pooja_date && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja Date</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{pooja_date}</span>
                                                            </div>
                                                        )}

                                                        {from_time && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja Time</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{formatTimeTo12Hour(from_time)}</span>
                                                            </div>
                                                        )}

                                                        {package_name && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Package Name</h6>
                                                                <button className="text-[12px] text-gray-900 font-semibold border border-gray-200 hover:text-white hover:bg-red-500 py-1 px-2 rounded" onClick={() => { handle_Package_Popup(package_detail) }}>{package_detail?.name}</button>
                                                            </div>
                                                        )}

                                                        {poojalocation && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Location</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{poojalocation}</span>
                                                            </div>
                                                        )}

                                                        {finalFullAddress && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Full Address</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{finalFullAddress}</span>
                                                            </div>
                                                        )}

                                                        {language && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Language</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{language}</span>
                                                            </div>
                                                        )}
                                                        {package_detail?.number_of_day && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Days of Pooja</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{package_detail?.number_of_day}</span>
                                                            </div>
                                                        )}
                                                        {package_detail?.number_of_pandit && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Number Of Pandit</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{package_detail?.number_of_pandit}</span>
                                                            </div>
                                                        )}
                                                        {package_detail?.duration && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja Duration</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{package_detail?.duration}</span>
                                                            </div>
                                                        )}

                                                        {muhurat_info && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Additional Information</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{muhurat_info}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!--cart content End --> */}
                        </div>
                        <div className="gi-checkout-rightside min-[992px]:w-[33.33%] w-full mt-10">
                            <div className="gi-sidebar-wrap mb-[30px]">
                                {/* <!-- Sidebar Summary Block --> */}

                                <div className="gi-sidebar-wrap p-[15px] shadow-xl mb-[0]">
                                    {/* <!-- Sidebar Summary Block --> */}
                                    <div className="gi-sidebar-block">
                                        <h4 className="font-bold text-sm text-black mb-2">Order Summery</h4>

                                        <div className="gi-sb-block-content mb-[0] border-b-[0] mt-[15px]">
                                            <div className="gi-cart-summary-bottom">
                                                <div className="gi-cart-summary">
                                                    <div className="flex justify-between items-center mb-[10px]">
                                                        <span
                                                            className="text-left font-medium text-gray-900 text-[12px] leading-[24px] tracking-[0]">{title}</span>
                                                        <span
                                                            className="text-right text-[#000] text-[12px] leading-[24px] font-medium">Rs.{price}/-</span>
                                                    </div>
                                                    <div className="flex justify-between items-center mt-[10px] pt-[10px] border-t border-gray-200">
                                                        <span
                                                            className="text-left text-gray-900 text-[13px] font-semibold leading-[24px] tracking-[0]">Total Amount</span>
                                                        <span
                                                            className="text-right text-[#000] text-[13px] font-semibold leading-[24px] font-medium">Rs.{(price || 0)}/-</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-5">
                                                {isBooking == true ? (
                                                    <button
                                                        disabled
                                                        type="button"
                                                        className="gi-btn-2 w-full transition-all duration-[0.3s] ease-in-out py-[10px] px-[15px] text-[14px]
                                                                 font-medium bg-[#9D2326] text-[#fff] text-center rounded-[5px] hover:bg-[#4b5966] hover:text-[#fff]"
                                                    >
                                                        Processing....
                                                    </button>
                                                ) : (
                                                    <Razor_Pay
                                                        Price={price}
                                                        onPaymentSuccess={handlePaymentSuccess}
                                                        buttonContent="Pay Now"
                                                        setIsBooking={setIsBooking}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- Sidebar Summary Block --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {package_popup && (
                <div className='fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4 backdrop-blur-sm transition-opacity duration-300'>
                    <div className='bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[85vh] transition-all transform scale-100 duration-300'>
                        <div className="relative bg-gradient-to-br from-red-50 to-[#FEE2E2] pt-8 pb-5 px-6 text-center border-b border-red-100/30 shrink-0">
                            <div className="absolute bottom-[-55px] left-0 right-0 z-10 pointer-events-none">
                                <svg className="w-full" height="122" viewBox="0 0 534 122" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 97.5001V0H533.333V97.5001C488.889 65.4241 444.444 65.4241 400 97.5001C355.556 129.576 311.111 129.576 266.667 97.5001C222.222 65.4241 177.778 65.4241 133.333 97.5001C88.8889 129.576 44.4444 129.576 0 97.5001Z" fill="#FEE2E2" />
                                </svg>
                            </div>
                            <button
                                onClick={close_Package_Popup}
                                className="absolute right-4 top-4 z-30 w-8 h-8 flex items-center justify-center bg-white/90 hover:bg-white text-gray-700 hover:text-gray-900 rounded-full shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none"
                            >
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <div className="relative z-20">
                                <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-[11px] font-bold uppercase tracking-wider rounded-full mb-2">Package Details</span>
                                <div className="text-gray-800 font-bold text-lg leading-tight mb-1">{package_popup?.name}</div>
                                <h3 className="text-red-700 font-extrabold text-2xl">₹ {new Intl.NumberFormat('en-IN').format(package_popup?.amount)}</h3>
                            </div>
                        </div>
                        <div className='p-6 pt-16 overflow-y-auto thin-scrollbar flex-1 space-y-5'>
                            <div>
                                <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">What's Included</h4>
                                <ul className="space-y-3">
                                    {package_popup?.packages?.length > 0 && package_popup?.packages?.map((list_item, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            {list_item?.is_included ? (
                                                <div className="flex items-center justify-center shrink-0 w-5 h-5 rounded-full bg-green-50 text-green-600 border border-green-200">
                                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                            ) : (
                                                <div className="flex items-center justify-center shrink-0 w-5 h-5 rounded-full bg-gray-50 text-gray-400 border border-gray-200">
                                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </div>
                                            )}
                                            <span className={`text-sm ${list_item?.is_included ? 'text-gray-700 font-medium' : 'text-gray-400 line-through'}`}>
                                                {list_item?.item_name}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Other Details */}
                            {(package_popup?.number_of_day || package_popup?.number_of_pandit || package_popup?.duration) && (
                                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 text-sm text-gray-700 space-y-2.5">
                                    {package_popup?.number_of_day && (
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-500 font-medium">Number of Days:</span>
                                            <span className="font-semibold text-gray-900">{package_popup?.number_of_day}</span>
                                        </div>
                                    )}
                                    {package_popup?.number_of_pandit && (
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-500 font-medium">Number of Pandits:</span>
                                            <span className="font-semibold text-gray-900">{package_popup?.number_of_pandit}</span>
                                        </div>
                                    )}
                                    {package_popup?.duration && (
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-500 font-medium">Duration:</span>
                                            <span className="font-semibold text-gray-900">{package_popup?.duration}</span>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Note Section */}
                            {package_popup?.notes && (
                                <div className="bg-amber-50/70 border border-amber-200/60 rounded-xl p-4">
                                    <div className="flex gap-2">
                                        <svg className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                        </svg>
                                        <p className="text-xs font-semibold text-amber-800 leading-relaxed">
                                            <span className="font-bold uppercase tracking-wider block mb-0.5">Important Note</span>
                                            {package_popup?.notes}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {/* Procedure Section */}
                            {package_popup?.procedure_involved && (
                                <div className="pt-2">
                                    <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Procedure Involved</h4>
                                    <div className="sub__title text-gray-700 text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: package_popup?.procedure_involved }} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Book_Pooja_Payment